import { hasModulePresetData } from '../../platform/scene-layout';
import { hydrateModelInstanceDetailToForm } from '../ModelInstance';
import { getTrainingClusterSharedVolumes } from './headless/trainingClusterSpec';
import type { TrainingClusterSpec } from './headless/trainingClusterSpec';
import { TC_SKU_MODULE_META } from './resourceConfigs';

/** 按表单/preset 数据把 envVars、initCommand 勾选打开 */
export function enrichTcSkuResourceModules(
  data: Record<string, unknown>,
  modules?: Record<string, boolean>,
): Record<string, boolean> | undefined {
  const hasEnv = hasModulePresetData(data, TC_SKU_MODULE_META.envVars);
  const hasInit = hasModulePresetData(data, TC_SKU_MODULE_META.initCommand);
  if (!modules && !hasEnv && !hasInit) return undefined;
  return {
    ...(modules ?? {}),
    ...(hasEnv ? { envVars: true } : {}),
    ...(hasInit ? { initCommand: true } : {}),
  };
}

/** 训练集群详情 → 直建编辑表单；包装 MI hydrate 后按数据同步可选模块勾选 */
export function hydrateTrainingClusterDetailToForm(detail: {
  metadata?: { name?: string; namespace?: string };
  spec?: TrainingClusterSpec;
}) {
  const modelInstanceValues = hydrateModelInstanceDetailToForm(detail as Parameters<typeof hydrateModelInstanceDetailToForm>[0]);
  const spec = detail.spec;
  const sharedVolumes = spec ? getTrainingClusterSharedVolumes(spec) : [];
  const skuResourceModules =
    enrichTcSkuResourceModules(
      modelInstanceValues as Record<string, unknown>,
      modelInstanceValues.skuResourceModules as Record<string, boolean> | undefined,
    ) ?? modelInstanceValues.skuResourceModules;

  return {
    ...modelInstanceValues,
    trainingClusterRunMode: 'alwaysOn' as const,
    trainingNicEnabled: !!spec?.network?.nics?.length,
    trainingSharedStorageEnabled: sharedVolumes.length > 0,
    trainingSharedVolumes: sharedVolumes,
    skuResourceModules,
  };
}
